/* WEST$HOP — shared behaviors: scroll reveal, carousels, image fallback */
(function () {
  'use strict';

  function init() {
    // Scroll reveal
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('in');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      document.querySelectorAll('.ws-reveal').forEach(function (el) {
        io.observe(el);
      });
    } else {
      document.querySelectorAll('.ws-reveal').forEach(function (el) {
        el.classList.add('in');
      });
    }

    // Carousel arrows
    document.querySelectorAll('.ws-car-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var el = document.getElementById(btn.dataset.target);
        if (!el) return;
        var step = Math.round(el.clientWidth * 0.8) * (btn.classList.contains('prev') ? -1 : 1);
        el.scrollBy({ left: step, behavior: 'smooth' });
      });
    });

    // Branded placeholder if a product photo cannot load
    function phSVG(alt) {
      var a = alt || 'Produit';
      var low = a.toLowerCase();
      var bg = '#e8352c';
      var glyph =
        "<g stroke='#fff' stroke-width='11' fill='none' stroke-linecap='round' stroke-linejoin='round'><path d='M158 235V92'/><path d='M158 100h98l-20 27 20 27h-98'/></g>";
      if (low.indexOf('money') !== -1) {
        bg = '#1d7a46';
        glyph =
          "<g><circle cx='200' cy='158' r='60' fill='none' stroke='#fff' stroke-width='11'/><text x='200' y='184' font-size='74' font-family='Arial' font-weight='bold' fill='#fff' text-anchor='middle'>$</text></g>";
      } else if (low.indexOf('honey') !== -1 || low.indexOf('miel') !== -1) {
        bg = '#c98a1b';
        glyph =
          "<path d='M200 96c-34 50-50 74-50 100a50 50 0 00100 0c0-26-16-50-50-100z' fill='#fff' opacity='.92'/>";
      }
      var name = a.replace(/mini gants?/i, '').trim().slice(0, 22);
      var svg =
        "<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'>" +
        "<rect width='400' height='400' fill='" + bg + "'/>" +
        "<rect x='14' y='14' width='372' height='372' fill='none' stroke='rgba(255,255,255,.5)' stroke-width='3' stroke-dasharray='10 8'/>" +
        glyph +
        "<text x='200' y='288' font-size='30' font-family='Arial, sans-serif' font-weight='bold' fill='#fff' text-anchor='middle'>" + name + "</text>" +
        "<text x='200' y='326' font-size='18' font-family='Arial, sans-serif' fill='rgba(255,255,255,.85)' text-anchor='middle'>WEST$HOP</text>" +
        '</svg>';
      return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    }
    function fixImg(im) {
      if (im.dataset.phDone || im.src.indexOf('data:') === 0) return;
      im.dataset.phDone = '1';
      im.src = phSVG(im.getAttribute('alt'));
    }
    document.querySelectorAll('.ws-cat-img img, .ws-card-img img, .ws-rail img, .ws-honey-visual img, .ws-spot-visual img').forEach(function (im) {
      im.addEventListener('error', function () {
        fixImg(im);
      });
      if (im.complete && im.naturalWidth === 0) fixImg(im);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
